import { defineComponent } from 'vue';
import {
  RequestForNotificationHydraItem,
  RequestForNotificationHydraItemType
} from '@/infrastructure/download-client/download-client';
import { markNotificationClosed, sanitizeNotificationContent } from '@/infrastructure/helpers/notifications';

export default defineComponent({
  name: 'dl-notifications',
  props: {
    notifications: {
      type: Array as () => RequestForNotificationHydraItem[],
      required: true
    }
  },
  setup: () => {
    const isError = (notification: RequestForNotificationHydraItem) => {
      return notification.type === RequestForNotificationHydraItemType.Error;
    };

    const isWarning = (notification: RequestForNotificationHydraItem) => {
      return notification.type === RequestForNotificationHydraItemType.Warning;
    };

    const removeNotification = (notificationId: string) => {
      const now = new Date();
      const closedAt = now.toISOString();

      markNotificationClosed(notificationId, closedAt);
    };

    return {
      isError,
      isWarning,
      removeNotification,
      sanitizeNotificationContent
    };
  }
});
